'use strict'

import Vuex from 'vuex'
import Vue from 'vue'
import getters from './getters'
import actions from './actions'
import state from './state'
import mutations from './mutations'

Vue.use(Vuex)

const store = new Vuex.Store({
	state,
	mutations: mutations(Vue),
	actions,
	getters
})

export default store



// WEBPACK FOOTER //
// ./src/common/store/index.js